<template>
    <el-container>
        <el-header>
            <div class="logoInfo">
                <!--                <img :src="require('@/assets/imgs/logo.png')" />-->
                <span @click="facili()">{{$t('system')}}</span>
            </div>
            <div class="userInfoBox">
                <div>
                  <el-switch
                    v-model="language"
                    @change="langChange(language)"
                    active-color="#ccc"
                    inactive-color="#ccc"
                    :active-text="language == 'zh' ? langs[1].labela : langs[1].labelb"
                    :inactive-text="language == 'zh' ? langs[0].labela : langs[0].labelb"
                    active-value="en"
                    inactive-value="zh">
                  </el-switch>
                </div>
                <div>
                    <i class="iconfont u-59" /><span>{{ date | formaDate }}</span>
                </div>
                <div @click="jump('/personal')">
                    <i class="iconfont u-yonghu1" /><span>{{ userName }}</span>
                </div>
                <div v-if="fcNameShow">
                    <el-dropdown @command="handleFactoryClick">
                        <span class="el-dropdown-link">
                            <!--切换工厂<i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>-->
                            {{ fcName }}
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item v-for="fc in factoryList" :key="fc.fcCode" :command="fc.fcCode">{{ fc.fcName }} </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
                <div style="cursor: pointer" @click="logOut"><i class="iconfont u-guanji" /><span>{{$t('base.exit')}}</span></div>
            </div>
        </el-header>
        <el-container>
            <el-aside width="auto">
                <div class="isCollapseBtn" :class="{ isCollapse: isCollapse }" @click="isCollapse = !isCollapse">
                    <i class="el-icon-s-fold"></i>
                </div>
                <Menu :isCollapse="isCollapse"></Menu>
            </el-aside>
            <el-main>
                <TagView :cache="true"></TagView>
                <div class="pageBox">
                    <transition name="fade-transform" mode="out-in">
                        <keep-alive>
                            <router-view :key="key" v-if="$route.meta ? $route.meta.keepAlive : false" />
                        </keep-alive>
                    </transition>
                    <transition name="fade-transform" mode="out-in">
                        <router-view :key="key" v-if="$route.meta ? !$route.meta.keepAlive : true" />
                    </transition>
                </div>
            </el-main>
        </el-container>
    </el-container>
</template>

<script>
import Menu from '../components/public/menu.vue'
import TagView from '../components/public/tagView.vue'
import { changeFactoryLogin } from '../libs/api'
//创建一个函数来增加月日时小于10在前面加0
var padaDate = function (value) {
  return value < 10 ? '0' + value : value
}
export default {
  name: 'Layout',
  components: {
    TagView,
    Menu
  },
  computed: {
    key () {
      return this.$route.fullPath
    }
  },
  data () {
    return {
      isCollapse: false, //菜单展开
      userInfo: {},
      userName: '',
      fcName: '',
      date: new Date(), //实时时间
      factoryList: [],
      roles: [],
      fcNameShow: false,
      language: localStorage.getItem('lang'),
      langs: [
        {
          value: 'zh',
          labela: '中',
          labelb: 'CN',
        },
        {
          value: 'en',
          labela: '英',
          labelb: 'EN',
        },
      ],
      langValue: false,
    }
  },
  mounted () {
    console.log('this.$store.state', this.$store.state)
    this.userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
    this.userName = this.userInfo.userName
    this.fcName = this.$store.state.userInfo.fcName
    if (this.fcName != undefined && this.fcName != '') {
      this.fcNameShow = true
    } else {
      this.fcNameShow = false
    }
    if (this.userInfo.fcCode && this.userInfo.fcCode=='JSPH') {
      this.$i18n.locale = 'en'
      this.language = 'en'
      localStorage.setItem('lang', 'en')
    } else {
      this.$i18n.locale = 'zh'
      this.language = 'zh'
      localStorage.setItem('lang', 'zh')
    }
    var _this = this //声明一个变量指向vue实例this,保证作用域一致
    this.timer = setInterval(function () {
      _this.date = new Date()//修改数据date
    }, 1000)
    this.init()
  },
  filters: {
    //设置一个函数来进行过滤
    formaDate: function (value) {
      //创建一个时间日期对象
      var date = new Date()
      var year = date.getFullYear()      //存储年
      var month = padaDate(date.getMonth() + 1)    //存储月份
      var day = padaDate(date.getDate())         //存储日期
      var hours = padaDate(date.getHours())      //存储时
      var minutes = padaDate(date.getMinutes())  //存储分
      var seconds = padaDate(date.getSeconds())  //存储秒
      //返回格式化后的日期
      return year + '年' + month + '月' + day + '日' + hours + '时' + minutes + '分' + seconds + '秒'
    }
  },
  methods: {
    langChange(item) {
      const lang = item
      this.$i18n.locale = lang
      this.language = lang
      localStorage.setItem('lang', lang)
    },
    facili () {
      this.$router.push({
        name: 'facilitySpectaculars',
        params: {
          full: "true"
        }
      })
    },
    //退出登录
    logOut () {
      sessionStorage.removeItem('authToken')
      sessionStorage.removeItem('userInfo')
      sessionStorage.removeItem('auths')
      sessionStorage.removeItem('editUserParam')
      sessionStorage.removeItem('dailyCheckDetail')
      sessionStorage.removeItem('editDeviceParam')
      sessionStorage.removeItem('AndonOrder')
      sessionStorage.removeItem('PlanMantainOrder')
      sessionStorage.removeItem('lingInfo')
      sessionStorage.removeItem('ifAddText')
      sessionStorage.removeItem('containDQue')
      sessionStorage.removeItem('eigDQueIfAddText')
      sessionStorage.removeItem('eigDQue')
      sessionStorage.removeItem('GigDTeam')
      sessionStorage.removeItem('eigDScoreQue')
      sessionStorage.removeItem('entranceDQue')
      sessionStorage.removeItem('putrightDQue')
      sessionStorage.removeItem('putrightVerifyDQue')
      sessionStorage.removeItem('reasonDQue')
      sessionStorage.removeItem('summarizeDQue')
      this.jump('/login')
    },
    init () {
      let options = {
        method: 'GET',
        url: this.$api.queryUserFactorys
      }
      var self = this
      this.$http.request(options).then(response => {
        if (response.status == 100) {
          if (response.data[0] != null) {
            self.factoryList = response.data
          }
        }
      })
    },
    handleFactoryClick (command) {
      this.$store.state.tagList = []
      console.log('command', command)
      let options = {
        method: 'POST',
        url: this.$api.changeFactoryLogin,
        params: {
          fcCode: command
        }
      }
      var self = this
      this.$http.request(options).then(response => {
        if (response.status == 100) {
          let userInfo = JSON.parse(JSON.stringify(response.data))
          console.log('userInfo', userInfo)
          sessionStorage.setItem('userInfo', JSON.stringify(userInfo))
          sessionStorage.setItem('authToken', response.data.token)
          self.roles = userInfo.roles
          self.$store.state.userInfo.roles = self.roles
          self.$store.state.userInfo.factoryId = userInfo.factoryId
          self.$store.state.userInfo.fcName = userInfo.fcName
          self.$store.state.userInfo.fcCode = userInfo.fcCode
          sessionStorage.setItem('store', JSON.stringify(self.$store.state))
          this.$router.go(0)
        }
      })
    }
  },
  beforeDestroy () {
    if (this.timer) {
      clearInterval(this.timer)//在vue实例销毁钱，清除我们的定时器
    }
  }
}
</script>

<style lang="scss" scoped></style>
